<div class="center-content fade-in-animation">
  <div class="report-title">Métricas até o período: {{reports[0]?.date | date:'MM/yy' : 'UTC'}}</div>

  <div class="report-cards-row">
    <report-card [title]="'Cadastrados'" [value]="(currentGroupData?.registered | number: '1.0-3') || '-'"
      [description]="'Descrição aqui'" [icon]="'user'" [iconType]="'feather-icons'">
    </report-card>

    <report-card [title]="'Adesão de cadastrados'"
      [value]="(currentGroupData?.adhered_registered | percent:'1.2-2') || '-'" [description]="'Descrição aqui'"
      [icon]="'user-plus'" [iconType]="'feather-icons'"
      [data]="[{ title: 'Aderidos', value: (currentGroupData?.adhered | number: '1.0-3') || '-' }]">
    </report-card>

    <report-card [title]="'Uso único no mês'" [value]="(currentGroupData?.use_registered | percent: '1.2-2') || '-'"
      [description]="'Descrição aqui'" [icon]="'check'" [iconType]="'feather-icons'"
      [data]="[{ title: 'Uso único', value: (currentGroupData?.use | number: '1.0-3') || '-' }]">
    </report-card>

    <report-card [title]="'Economia Potencial'"
      [value]="(currentGroupData?.potentialEconomy | currency:'BRL':'symbol':'1.2-2') || '-'"
      [description]="'Descrição aqui'" [icon]="'usd'"
      [data]="[{ title: 'Economia lançada', value: (currentGroupData?.launchedEconomy | currency:'BRL':'symbol':'1.2-2') || '-' }]">
    </report-card>

    <report-card [title]="'Cupons Gerados'" [value]="(currentGroupData?.coupons | number: '1.0-3') || '-'"
      [description]="'Descrição aqui'" [icon]="'ticket'" [data]="[
        { title: 'Cinema', value: (currentGroupData?.cinema_value | currency:'BRL':'symbol':'1.2-2') || '-' }]">
    </report-card>

    <report-card [title]="'Total de endereços de parceiros'"
      [value]="(places[0]?.totalAddresses | number: '1.0-3') || '-'" [description]="'Descrição aqui'"
      [icon]="'map-marker'"
      [data]="[{ title: 'Total parceiros únicos', value: (places[0]?.total | number: '1.0-3') || '-' }]">
    </report-card>
  </div>

  <div class="card">
    <div class="card-content">

      <div class="card-header">
        <h4 class="no-margin">Métricas de adesão</h4>
        <info-tooltip [description]="'Descrição'"></info-tooltip>
      </div>

      <div class="chart-container">
        <canvas id="canvas" width="990" height="275"></canvas>
      </div>

      <ngx-datatable class="report-table" [headerHeight]="'auto'" [rowHeight]="28" [columnMode]="columnModes.flex"
        [rows]="grownMetricsRows" [columns]="grownMetricsColumns">
      </ngx-datatable>

    </div>
  </div>
</div>